/***
 * 姓名 :D
 * 创建时间:2019-3-8
 * 描述：websocket 消息队列服务
 * 更新记录：
 */
import { Injectable } from '@angular/core';
import { Subject, Observable, Observer } from 'rxjs';
import { SwHttpClientService } from './sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwJwtService } from './sw-jwt.service';

@Injectable()
export class SwWebSocketService {

  public a01:any;
  public ws :any;
  constructor(
    private http:SwHttpClientService,
    private jwt:SwJwtService,
    ) { }

  /**
   * 消息队列公共方法
   * @param uri 请求的消息队列参数
   * @param param uri的参数
   * @param path  请求成功后访问
   */
  public create(uri:string,path?:string):Subject<MessageEvent>{
    this.ws = new WebSocket(uri);
    this.ws.onopen =  ()=>{
      // 注释勿删
      // this.http.Post(environment.seekerWebAPI+ "/message/sendMessage",{}).subscribe(data=>{})  //请求所有消息, 会一条一条推送过来 
    };
    
    let observable = Observable.create(
      (obs:Observer<MessageEvent>) =>{
        this.ws.onmessage = obs.next.bind(obs);
        this.ws.onerror = obs.error.bind(obs);
        this.ws.onclose = obs.complete.bind(obs);
        return this.ws.close.bind(this.ws);
      });
      let observer = {
        next:(data:any)=>{
          if(this.ws.readyState === WebSocket.OPEN){
            this.ws.send(data);
          }
        }
      };
      return Subject.create(observer,observable)
  }

  public close(){
    this.ws.onclose();
  }

  
  public open(){
    this.ws.onopen();
  }

}
